// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b92d5c6","268":"8dd13491","484":"ac3f0ed3","519":"cc7969e4","551":"6bced7a5","842":"c555e1cb"}[chunkId] + ".chunk.js";
};